<template>
  <v-form ref="advancePaymentForm" height="100%" v-model="valid" @submit.prevent="submitForm">
    <block v-if="loading"></block>
    <v-card>
      <v-card-title>
        <h3>Registrar Anticipo</h3>
      </v-card-title>
      <v-card-text class="w-full">
        <v-row class="mt-2">
          <v-col cols="12" md="6">
            <CustomAutoComplete
              key="customer_id"
              v-if="true"
              label="Seleccionar Cliente por ID"
              v-model="form.ID_Customer"
              :search="{ ...search, filteredFrom: 2 }"
              :items="customers"
              :item-text="'ID_Customer'"
              :item-value="'ID_Customer'"
              :filter-endpoint="$API.customers.filterCustomers"
              @select="onCustomerSelect"
              @updateItems="updateCustomers"
            />
          </v-col>
          <v-col cols="12" md="6">
            <CustomAutoComplete
              key="customer_name"
              v-if="true"
              label="Seleccionar Cliente por Nombre"
              v-model="form.ID_Customer"
              :search="{ ...search, filteredFrom: 2 }"
              :items="customers"
              :item-text="'itemText'"
              :item-value="'ID_Customer'"
              :filter-endpoint="$API.customers.filterCustomers"
              @select="onCustomerSelect"
              @updateItems="updateCustomers"
            />
          </v-col>
          <v-col cols="12" md="6">
            <date-picker
              label="Fecha de Pago"
              v-model="form.DatePayment"
              @dateSelected="(newValue) => (form.DatePayment = newValue)"
              dense
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="form.Payment"
              label="Monto del Anticipo"
              type="number"
              outlined
              dense
              required
              :rules="[(v) => !!v || 'El monto es requerido']"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-select
              v-model="form.TypePayment"
              :items="paymentTypes"
              item-text="Valores"
              item-value="Codigo_Alt"
              label="Tipo de Pago"
              @change="updateDescription"
              outlined
              dense
              required
              :rules="[(v) => !!v || 'El tipo de pago es requerido']"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="form.Reference"
              label="Referencia"
              outlined
              dense
              :disabled="!isReferenceEnabled"
              :required="isReferenceRequired"
              :rules="referenceRules"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-textarea
              v-model="form.Comment"
              label="Comentario"
              outlined
              dense
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="closeModal" class="btndisable">Cancelar</v-btn>
        <v-spacer></v-spacer>
        <v-btn :disabled="!valid" @click="submitForm" class="btn-save"
          >Registrar Anticipo</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import { mapGetters } from "vuex";
import CustomAutoComplete from "@/components/CustomAutoComplete.vue";
import DatePicker from "@/components/DatePicker";
import moment from "moment";

export default {
  name: "AdvancePaymentForm",
  components: {
    CustomAutoComplete,
    DatePicker,
  },
  props: ["win"],
  data() {
    return {
      loading: false,
      valid: false,
      defaultForm: {
        ID_Customer: "",
        CustomerName: "",
        DatePayment: moment().format("DD/MM/YYYY"),
        Payment: 0,
        Comment: "",
        IsActive: true,
        ID_Business: null,
        ID_Branch: null,
        TypePayment: "",
        DescriptionPayment: "",
        Reference: "",
        isDeleted: 0
      },
      form: {
        ID_Customer: "",
        CustomerName: "",
        DatePayment: moment().format("DD/MM/YYYY"),
        Payment: 0,
        Comment: "",
        IsActive: true,
        ID_Business: null,
        ID_Branch: null,
        TypePayment: "",
        DescriptionPayment: "",
        Reference: "",
        isDeleted: 0,
      },
      branch: null,
      business: null,
      customers: [],
      search: {
        filter: "",
        filteredFrom: 2,
      },
    };
  },
  mounted() {
    try {
      this.reset()
      this.business = JSON.parse(localStorage.getItem("user")).businessid;
      this.branch = JSON.parse(localStorage.getItem("user")).branch;
      this.search.business = this.business;
      this.search.branch = this.branch;
      this.form.ID_Business = this.business;
      this.form.ID_Branch = this.branch;
    } catch (error) {
      console.error(error);
    }
  },
  methods: {
    reset() {
      this.form = { ...this.defaultForm }
    },
    async getCustomers() {
      try {
        this.loading = true;
        const customersResponse = await this.$API.customers.filterCustomers(
          this.search
        );
        this.customers = this.mapCustomerFromNameToItemText(customersResponse);

      } catch (error) {
        console.error("Error fetching customers:", error);
      } finally {
        this.loading = false;
      }
    },
    onCustomerSelect(customer) {
      this.form.ID_Customer = customer;
    },
    updateCustomers(newItems) {
      this.customers = this.mapCustomerFromNameToItemText(newItems);
    },
    mapCustomerFromNameToItemText(customers) {
      return customers.map((customer) => {
        customer.itemText = customer.Is_a_business
          ? customer.BusinessName
          : customer.LegalName;
        return customer;
      });
    },
    async submitForm() {
      if (this.$refs.advancePaymentForm) {
        const isValid = this.$refs.advancePaymentForm.validate();
        if (!isValid) {
          return;
        }
      }

      this.loading = true;
      try {
        await this.$API.customerAdvancePayment.createAdvancePayment(this.form);
        this.$emit("success", "Anticipo registrado exitosamente.");
        this.closeModal();
      } catch (error) {
        console.error("Error creating advance payment:", error);
        this.$emit("error", "Error al registrar el anticipo.");
      } finally {
        this.loading = false;
      }
    },
    closeModal() {
      this.form = {
        ID_Customer: "",
        CustomerName: "",
        DatePayment: moment().format("DD/MM/YYYY"),
        Payment: 0,
        Comment: "",
        IsActive: true,
        ID_Business: this.form.ID_Business,
        ID_Branch: this.form.ID_Branch,
        TypePayment: "01",
        DescriptionPayment: "",
        Reference: "",
      };
      this.$emit("close");
    },
    updateDescription() {
      const selectedPaymentType = this.paymentTypes.find(
        (type) => type.Codigo_Alt === this.form.TypePayment
      );
      this.form.DescriptionPayment = selectedPaymentType
        ? selectedPaymentType.Valores
        : "";
      this.$nextTick(() => {
        if (this.$refs.advancePaymentForm) {
          this.$refs.advancePaymentForm.validate();
        }
      });
    },
  },
  computed: {
    ...mapGetters(["getCatalogMH"]),
    paymentTypes() {
      return this.getCatalogMH("FormaPago");
    },
    normalizedTypePayment() {
      const rawValue = this.form.TypePayment;
      const stringValue = rawValue == null ? "" : String(rawValue).trim();
      const primaryCode = stringValue.includes("-")
        ? stringValue.split("-")[0]
        : stringValue;
      return primaryCode.length === 1 ? `0${primaryCode}` : primaryCode;
    },
    isReferenceEnabled() {
      return this.normalizedTypePayment !== "01";
    },
    isReferenceRequired() {
      return ["04", "05", "14"].includes(this.normalizedTypePayment);
    },
    referenceRules() {
      return [
        (value) => !this.isReferenceRequired || !!value || "La referencia es requerida",
      ];
    },
  },
};
</script>

<style scoped>
.btndisable {
  background-color: #41464c !important;
  color: white;
}

.btnsave {
  background-color: #00a178 !important;
  color: white;
}
</style>
